import http from "@/utils/axios";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    referrals: [],
    referralGroups: [],
    pagination: {
      currentPage: 1,
      total: 1,
    },
    currentReferral: null,
    stats: {
      referrals_count: 0,
      avg_referrals_count: 0,
      avg_referrals_price: 0,
    },
    commissionRange: [1, 100],
    priceRange: [1, 1000],
  },
  getters: {
    getReferrals: (state) => state.referrals,
    getPagination: (state) => state.pagination,
    getCurrentReferral: (state) => state.currentReferral,
    getReferralGroups: (state) => state.referralGroups,
  },
  mutations: {
    setReferralGroups(state, referralGroups) {
      state.referralGroups = referralGroups;
    },
    setReferrals(state, referrals) {
      state.referrals = referrals.data;
      state.pagination.currentPage = referrals.meta.current_page;
      state.pagination.total = referrals.meta.last_page;
    },
    setCurrentPage(state, currentPage) {
      state.pagination.currentPage = currentPage;
    },
    setCurrentReferral(state, currentReferral) {
      state.currentReferral = currentReferral;
    },
    setCurrentReferralPatient(state, patient) {
      state.currentReferral.patient = patient;
    },
    setStats(state, stats) {
      state.stats = stats;
    },
    setCommissionRange(state, commissionRange) {
      state.commissionRange = commissionRange;
    },
    setPriceRange(state, priceRange) {
      state.priceRange = priceRange;
    },
    clearReferrals(state) {
      state.referrals = [];
      state.pagination.currentPage = 1;
      state.pagination.total = 1;
    },
    setPagination(state, { currentPage, total }) {
      state.pagination.currentPage = currentPage;
      state.pagination.total = total;
    },
  },
  actions: {
    async fetchReferrals(
      { commit, state, rootGetters },
      { time = "current_month", date_range = null, filters, sortBy }
    ) {
      const { data } = await http.get("referrals", {
        params: {
          page: state.pagination.currentPage,
          time: time,
          date_range: date_range,
          ...filters,
          ...sortBy,
        },
      });
      commit("setReferrals", data.referrals);
      commit("user/setCurrentUserStats", data.stats, { root: true });
      let userRole = rootGetters["user/getCurrentUserRole"];
      if (userRole !== "patient")
        commit("referrals/setCommissionRange", data.commission_range, {
          root: true,
        });
    },
    async checkResults({ commit, state }, id) {
      const { data } = await http.get(`referrals/check-results/${id}`, {
        params: {
          page: state.pagination.currentPage,
        },
      });
      commit("setPagination", {
        currentPage: data.meta.current_page,
        total: data.meta.last_page,
      });
      commit("setReferralGroups", data.data);
    },
    async fetchReferralGroups({ commit, state }, params = {}) {
      const { data } = await http.get("referralGroups", {
        params: {
          page: state.pagination.currentPage,
          ...params,
        },
      });
      commit("setPagination", {
        currentPage: data.meta.current_page,
        total: data.meta.last_page,
      });
      commit("setReferralGroups", data.data);
    },
    async fetchCurrentReferral({ commit }, id) {
      return await http
        .get(`/referrals/${id}`)
        .then(({ data }) => {
          commit("setCurrentReferral", data.referral);

          return data.referral;
        })
        .catch(async ({ response }) => {
          if ([401, 403].includes(response?.status)) {
            await router.push({
              name: "ErrorCode",
              params: { code: response?.status },
            });
            router.go(0);
          }
        });
    },
  },
};
